import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Container, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export function BrandedLayout({ children }: Props) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#F1F5F9",
      }}
    >
      {/* Header claro y cohesivo con el cuerpo. El logo (fondo blanco) se funde
          sobre el header blanco, así que se ve nítido y prominente sin la banda
          oscura anterior. */}
      <Box
        component="header"
        sx={{
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
          px: { xs: 2, sm: 4 },
          py: { xs: 1.25, sm: 1.5 },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {/* El procesador acompaña, no protagoniza: quien cobra es el comercio
              y su identidad va dentro de la tarjeta. Este logo se mantiene
              legible pero deliberadamente más chico que antes. */}
          <Box
            sx={{
              height: { xs: 34, sm: 40 },
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src="/brand/logo.png"
              alt="Novasis Pay"
              sx={{
                height: { xs: 40, sm: 46 }, // recorta apenas el padding (este logo trae poco)
                width: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </Box>
          <Stack direction="row" alignItems="center" spacing={0.6}>
            <LockOutlinedIcon sx={{ fontSize: 15, color: "success.main" }} />
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontWeight: 600, letterSpacing: 0.2 }}
            >
              Pago seguro
            </Typography>
          </Stack>
        </Stack>
      </Box>

      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          py: { xs: 3.5, sm: 6 },
        }}
      >
        {children}
      </Box>

      <Box component="footer" sx={{ pb: 3 }}>
        <Container maxWidth="sm">
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", display: "block", textAlign: "center" }}
          >
            Procesado por <strong>Novasis Pay</strong> · novasispy.com
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
